import { FC } from "react";
import { IConsent } from "../../shared/types";
import { CheckboxConsent } from "./CheckboxConsent";
import { NoticeConsent } from "./NoticeConsent";
import { RadioConsent } from "./RadioConsent";

interface Props {
	consent: IConsent;
	name?: string;
}

export const RegistrationConsent: FC<Props> = ({ consent, name }) => {
	const fieldName = name ? `${name}.${consent.id}` : `${consent.id}`;
	switch (consent.type) {
		case "checkbox":
			return <CheckboxConsent consent={consent} name={fieldName} />;
		case "radio":
			return <RadioConsent consent={consent} name={fieldName} />;
		case "notice":
		default:
			return <NoticeConsent consent={consent} />;
	}
};
